import { get, post } from './request'

export const MINIMUM_CUL_VERSION = '1.0' // 当前app支持的最小CUL版本号
export const TARGET_CUL_VERSION = '1.3' // 当前app支持的最大CUL版本号

// 查询神象云特惠套餐列表 http://yapi.sui.work/project/379/interface/api/172266
export const queryPrepaidPlans = () => {
  return get('/cab-service-ws/v1/prepaid-plans', {})
}

// 用户余额查询 http://yapi.sui.work/project/379/interface/api/164930
export const fetchAccounts = (params: any) => {
  return get('/cab-service-ws/v1/accounts', params)
}

// 用户预购买操作支付 http://yapi.sui.work/project/379/interface/api/171153
export const prePaid = (params: any) => {
  return post('/cab-service-ws/v1/book/prepaid/pay', params, {
    loading: true,
    showError: false,
    errorMsg: '支付失败，请稍后再试~'
  })
}

// 查询用户类型：1 主人 2 管理员 3 成员 http://yapi.sui.work/project/379/interface/api/168044
export const fetchUserType = () => {
  return get('/cab-service-ws/account-book/user-type')
}

// 查询账本下购买的服务套餐 http://yapi.sui.work/project/379/interface/api/171195
export const fetchPlan = () => {
  return get('/cab-service-ws/v1/book/prepaid/plan', {}, {
    loading: false,
    showError: false
  })
}

// 获取用户账本列表 http://yapi.sui.work/project/379/interface/api/172028
export const fetchAccountBooks = (params: any = {}) => {
  return get('/cab-service-ws/v3/user/account-books', params, {
    loading: false,
    showError: false
  })
}

/**
 * 添加账本 http://yapi.sui.work/project/328/interface/api/157524
 */
export const addAccountBook = (id: string) => {
  // const header = {
  //   'minimum-cul-version': MINIMUM_CUL_VERSION,
  //   'target-cul-version': TARGET_CUL_VERSION
  // }
  return post('/cab-config-ws/v2/account-books', { id, dfrom: '' }, {
    loading: false,
    showError: false
  })
}

/**
 * 查询用户订单状态 http://yapi.sui.work/project/379/interface/api/172021
 * @param prepaid_order_id 订单id
 * @param prepaid_order_status 订单状态：0 待支付  1 支付成功 2 处理中 3 支付失败 4 支付异常 5支付超时
 * @returns
 */
export enum orderStatus { unpaid, succeed, processing, fail, error, timeout }

export const prepaidOrders = (params = { prepaid_order_id: '', prepaid_order_status: '' }) => {
  return get('/cab-service-ws/v1/user/prepaid-plans/orders', params, {
    loading: false,
    showError: false
  })
}

/**
 * 匹配最小充值档位选项 http://yapi.sui.work/project/379/interface/api/172014
 * @returns
 */
export const payNeedMin = (params: any) => {
  return get('/cab-service-ws/account/payment-cashier/pay-options/need-min', params, {
    loading: false,
    showError: false
  })
}
